import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiLayers, FiVideo, FiTag, FiList, FiHash, FiImage, FiUsers, FiCreditCard, FiRotateCcw, FiChevronDown, FiUpload, FiClock } from 'react-icons/fi';
import './Sidebar.css';

function Sidebar() {
  const [cmsOpen, setCmsOpen] = useState(true);
  const [paymentsOpen, setPaymentsOpen] = useState(true);

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src={`${process.env.PUBLIC_URL || ''}/logo.png`} alt="" className="sidebar-brand-logo" />
        <div className="sidebar-brand-text-wrap">
          <span className="sidebar-brand-text">BabyBillion</span>
          <span className="sidebar-brand-badge">Admin</span>
        </div>
      </div>
      <nav className="sidebar-nav">
        <span className="sidebar-section-label">Content</span>
        <div className="sidebar-group">
          <div className={`sidebar-parent-row ${cmsOpen ? 'expanded' : ''}`}>
            <NavLink
              to="/dashboard/cms/video"
              className={({ isActive }) => `sidebar-link sidebar-link-parent ${isActive ? 'active' : ''}`}
            >
              <FiLayers className="sidebar-icon sidebar-icon-parent" aria-hidden />
              <span>CMS</span>
            </NavLink>
            <button
              type="button"
              className="sidebar-chevron-btn"
              onClick={() => setCmsOpen((o) => !o)}
              aria-expanded={cmsOpen}
              aria-label={cmsOpen ? 'Collapse CMS' : 'Expand CMS'}
            >
              <FiChevronDown className={`sidebar-chevron ${cmsOpen ? 'sidebar-chevron-open' : ''}`} aria-hidden />
            </button>
          </div>
          <div className={`sidebar-sublinks ${cmsOpen ? 'open' : ''}`}>
            <div className="sublink-inner">
              <NavLink
                to="/dashboard/cms/video"
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiVideo className="sidebar-sublink-icon" aria-hidden />
                Video
              </NavLink>
              <NavLink
                to="/dashboard/cms/category"
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiTag className="sidebar-sublink-icon" aria-hidden />
                Parent categories
              </NavLink>
              <NavLink
                to="/dashboard/cms/playlist"
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiList className="sidebar-sublink-icon" aria-hidden />
                Categories
              </NavLink>
              <NavLink
                to="/dashboard/cms/tags"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiHash className="sidebar-sublink-icon" aria-hidden />
                Tags
              </NavLink>
              <NavLink
                to="/dashboard/cms/thumbnail-generator"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiImage className="sidebar-sublink-icon" aria-hidden />
                Video thumbnail generator
              </NavLink>
              <NavLink
                to="/dashboard/cms/bulk-upload"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiUpload className="sidebar-sublink-icon" aria-hidden />
                Bulk upload
              </NavLink>
              <NavLink
                to="/dashboard/cms/job-history"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiClock className="sidebar-sublink-icon" aria-hidden />
                Job history
              </NavLink>
            </div>
          </div>
        </div>
        <span className="sidebar-section-label">Management</span>
        <NavLink
          to="/dashboard/user"
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
        >
          <FiUsers className="sidebar-icon" aria-hidden />
          <span>User</span>
        </NavLink>
        <div className="sidebar-group">
          <div className={`sidebar-parent-row ${paymentsOpen ? 'expanded' : ''}`}>
            <NavLink
              to="/dashboard/payments"
              className={({ isActive }) => `sidebar-link sidebar-link-parent ${isActive ? 'active' : ''}`}
            >
              <FiCreditCard className="sidebar-icon sidebar-icon-parent" aria-hidden />
              <span>Payments</span>
            </NavLink>
            <button
              type="button"
              className="sidebar-chevron-btn"
              onClick={() => setPaymentsOpen((o) => !o)}
              aria-expanded={paymentsOpen}
              aria-label={paymentsOpen ? 'Collapse Payments' : 'Expand Payments'}
            >
              <FiChevronDown className={`sidebar-chevron ${paymentsOpen ? 'sidebar-chevron-open' : ''}`} aria-hidden />
            </button>
          </div>
          <div className={`sidebar-sublinks ${paymentsOpen ? 'open' : ''}`}>
            <div className="sublink-inner">
              <NavLink
                to="/dashboard/payments"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiCreditCard className="sidebar-sublink-icon" aria-hidden />
                View / Manage Payments
              </NavLink>
              <NavLink
                to="/dashboard/payments/history"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiCreditCard className="sidebar-sublink-icon" aria-hidden />
                View payment history
              </NavLink>
              <NavLink
                to="/dashboard/payments/refund"
                end
                className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              >
                <FiRotateCcw className="sidebar-sublink-icon" aria-hidden />
                Refund
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
    </aside>
  );
}

export default Sidebar;
